import React from 'react'
import usePermissions from '../hooks/usePermissions'
import { Navigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../redux/messageSlice'

const CustomProtectedRoute = ({permission, children, isFromTeamsDashboard}) => {

    const [hasPermission] = usePermissions()
    const dispatch = useDispatch();

    // if(!hasPermission(permission)){
    //     dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!"}))
    //     return isFromTeamsDashboard ? <Navigate to='/dashboard/teams'/> :  <Navigate to='/dashboard'/>
    // }
    
     if(!permission){
        dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!"}))
        return  <Navigate to='/dashboard'/>
    }

  return children
  
}

export default CustomProtectedRoute